import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { sdkStateService } from './sdkStateService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const page: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(sdkStateService)
}

export const editorPage = page
